import styled from 'styled-components'
import { containerCss } from 'utilities/widget'
import { Rows } from 'components/flex'

export const Container = styled(Rows)`
    ${containerCss}
`
